module.exports = __webpack_public_path__ + "static/img/banner_solutions_professional.fb756f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/resource/images/solution/banner_solutions_professional.png
// module id = 9ogA
// module chunks = 10